





import {Component} from "vue-property-decorator"
import Vue from "vue"
import InjectFunctional from "@/content/1-start/UtilitiesSupport/InjectFunctional.vue"

@Component({
    components: {InjectFunctional}
})
export default class InjectPassthrough extends Vue {
}
